export default () => {
    const href = window.location.href;
    return (href.includes("/correspondence/") || href.includes("/nationalNotice/") || href.includes("/offer/contractor/") || //
        (href.includes("/purchaser/demand") && href.includes("/preview")));
}